import styled from "styled-components";
import { useState, useContext, useEffect } from "react";
import { sendNotification } from "../../../Firebase";

const AdminNotificationsWrapper = styled.div`
  padding-top: 10px;
  input{
    width: 80%;
    height: fit-content;
    padding: 5px;
  }
`;

export default function AdminNotifications(props: Props) {
    const [message, setMessage] = useState("");

    function handleSendNotification(){
        sendNotification(message, "ABCDEFG12345")
    }
  return <AdminNotificationsWrapper>
    <h2>Admin Notifications</h2>
    <p>FCM Tocken: {props.FCMToken}</p>
    <input value={message} onChange={(e)=> setMessage(e.target.value)} type="text" />
    <button onClick={handleSendNotification}>Send Message</button>

  </AdminNotificationsWrapper>;
}

interface Props {
    FCMToken: string;
}
